export const PART_SOURCE = [
  { code: 'ALT', description: 'Alternate' },
  { code: 'AM', description: 'After Market' },
  { code: 'EX', description: 'Exchange' },
  { code: 'OEM', description: 'OEM' },
  { code: 'R', description: 'Recycled' }
];
